var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCsHourglass = function SvgCsHourglass(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 0C0.9 0 0 0.9 0 2L0.0100002 5.18C0.0100002 5.71 0.22 6.21 0.59 6.59L4 10L0.59 13.43C0.22 13.8 0.0100002 14.31 0.0100002 14.84L0 18C0 19.1 0.9 20 2 20H10C11.1 20 12 19.1 12 18V14.84C12 14.31 11.79 13.8 11.42 13.43L8 10L11.41 6.6C11.79 6.22 12 5.71 12 5.18V2C12 0.9 11.1 0 10 0H2ZM10 14.91V17C10 17.55 9.55 18 9 18H3C2.45 18 2 17.55 2 17V14.91C2 14.64 2.11 14.39 2.29 14.2L6 10.5L9.71 14.21C9.89 14.39 10 14.65 10 14.91Z",
    fill: "#260046"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCsHourglass);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cs-hourglass.0fbe2d50397486f547fa8f4a10daf175.svg";